import { Link } from "react-router-dom";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-control font-body font-extrabold tracking-[0.01em] transition-[transform,box-shadow,background-color,color] duration-300 min-h-[54px] px-7 text-sm sm:text-[15px] hover:-translate-y-[2px] disabled:opacity-60 disabled:pointer-events-none";

const variants = {
  primary: "bg-coralInk text-white shadow-soft hover:shadow-softLg",
  secondary: "bg-amber text-cocoa shadow-soft hover:shadow-softLg",
  outline: "bg-surface text-cocoa border border-line shadow-soft hover:shadow-softLg",
  ghost: "bg-transparent text-coralInk hover:bg-sageSoft hover:translate-y-0",
  onDark: "bg-amber text-cocoa shadow-soft hover:shadow-softLg",
};

export const CTAButton = ({
  to,
  href,
  variant = "primary",
  className = "",
  children,
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button type="button" className={cls} {...rest}>{children}</button>;
};

export default CTAButton;
